<template>
  <div class="video-stat">
    <!-- 统计卡片 -->
    <div class="stats-cards">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <div class="stats-card">
            <div class="stats-icon total">
              <i class="el-icon-video-camera"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ statistics.totalVideos || 0 }}</div>
              <div class="stats-label">视频总数</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <div class="stats-card">
            <div class="stats-icon published">
              <i class="el-icon-check"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ statistics.publishedVideos || 0 }}</div>
              <div class="stats-label">已发布</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <div class="stats-card">
            <div class="stats-icon pending">
              <i class="el-icon-clock"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ statistics.pendingAudit || 0 }}</div>
              <div class="stats-label">待审核</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <div class="stats-card">
            <div class="stats-icon rejected">
              <i class="el-icon-close"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ statistics.rejectedVideos || 0 }}</div>
              <div class="stats-label">已拒绝</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <div class="stats-card">
            <div class="stats-icon views">
              <i class="el-icon-view"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ formatNumber(statistics.totalViews || 0) }}</div>
              <div class="stats-label">总播放量</div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
          <div class="stats-card">
            <div class="stats-icon likes">
              <i class="el-icon-star-on"></i>
            </div>
            <div class="stats-content">
              <div class="stats-number">{{ formatNumber(statistics.totalLikes || 0) }}</div>
              <div class="stats-label">总点赞数</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="searchNav">
      <div class="search-form">
        <div class="search-items">
          <div class="search-item">
            <span class="label">视频标题：</span>
            <el-input v-model="searchInfo.title" clearable placeholder="请输入"></el-input>
          </div>
          <div class="search-item">
            <span class="label">审核状态：</span>
            <el-select v-model="searchInfo.reviewStatus" clearable @change="search" placeholder="请选择">
              <el-option v-for="(item, i) in statusList" :key="i" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <span class="label">用户名称：</span>
            <el-input v-model="searchInfo.nickname" clearable placeholder="请输入用户名称"></el-input>
          </div>
          <div class="search-item">
            <span class="label">用户号码：</span>
            <el-input v-model="searchInfo.phone" clearable placeholder="请输入用户号码"></el-input>
          </div>
          <div class="search-item date-picker">
            <span class="label">创建时间：</span>
            <el-date-picker v-model="searchDateArr" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
              :picker-options="pickerOptions">
            </el-date-picker>
          </div>
        </div>
      </div>
      <div class="search-btn">
        <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button type="success" icon="el-icon-refresh" @click="refreshStats">刷新统计</el-button>
      </div>
    </div>
    <div class="tableStyle">
      <el-table v-loading="loading" :data="tableData" style="width: 100%;" max-height="600px" @row-dblclick="handleRowDblClick">
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="coverUrl" label="封面" width="100">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.coverUrl"
              :src="scope.row.coverUrl"
              :preview-src-list="[scope.row.coverUrl]"
              style="width: 60px; height: 40px; border-radius: 4px;"
              fit="cover"
            />
          </template>
        </el-table-column>
        <el-table-column prop="description" label="视频标题" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column prop="nickname" label="用户名称" width="80">
          <template slot-scope="scope">
            <el-button type="text" @click="showUserDetail(scope.row)">{{ scope.row.nickname }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="用户号码" width="120">
          <template slot-scope="scope">
            {{ scope.row.phone }}
          </template>
        </el-table-column>
        <el-table-column prop="duration" label="时长" width="80">
          <template slot-scope="scope">
            {{ formatDuration(scope.row.duration) }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.status)">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column> -->

        <el-table-column prop="reviewStatus" label="审核状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType1(scope.row.reviewStatus)">
              {{ showApprovalStatus(scope.row.reviewStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="viewCount" label="播放量" width="80">
          <template slot-scope="scope">
            <span style="color: #409EFF; font-weight: 500;">{{ formatNumber(scope.row.viewCount) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="likeCount" label="点赞" width="60">
          <template slot-scope="scope">
            <span style="color: #67C23A;">{{ scope.row.likeCount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="commentCount" label="评论" width="60">
          <template slot-scope="scope">
            <span style="color: #E6A23C;">{{ scope.row.commentCount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="shareCount" label="分享" width="60">
          <template slot-scope="scope">
            <span style="color: #909399;">{{ scope.row.shareCount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="collectCount" label="收藏" width="60">
          <template slot-scope="scope">
            <span style="color: #F56C6C;">{{ scope.row.collectCount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="160" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" size="small"  @click="viewDetail(scope.row)">详情</el-button>
            <el-button type="text" size="small"  @click="auditVideo(scope.row)">审核</el-button>
            <el-button type="text" size="small" @click="confirmDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
          </template>
        </el-table-column>
        <!-- 自定义空数据展示 -->
        <template slot="empty">
          <div class="empty-container">
            <el-empty :image-size="200"></el-empty>
          </div>
        </template>
      </el-table>
      <el-pagination style="text-align: right;"
                     @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page.sync="currentPage"
                     :page-size="searchInfo.pageSize"
                     :page-sizes="[10,20, 50, 100]"
                     layout="sizes, prev, pager, next ,total"
                     :total="total">
      </el-pagination>
    </div>

    <!-- 视频详情弹窗 -->
    <el-dialog
      title="视频详情"
      :visible.sync="videoDetailVisible"
      width="800px"
      :before-close="handleClose">
      <div v-if="videoDetail">
        <div class="video-detail">
          <div class="video-preview">
            <div class="video-cover">
              <el-image
                v-if="videoDetail.coverUrl"
                :src="videoDetail.coverUrl"
                style="width: 200px; height: 120px; border-radius: 8px; cursor: pointer;"
                fit="cover"
                @click="playVideo"
              />
              <div class="play-icon" @click="playVideo">
                <i class="el-icon-video-play"></i>
              </div>
            </div>
            <div class="video-info">
              <h3>{{ videoDetail.title }}</h3>
              <p class="description">{{ videoDetail.description }}</p>
              <div class="meta-info">
                <span class="duration">时长: {{ formatDuration(videoDetail.duration) }}</span>
                <span class="resolution" v-if="videoDetail.width && videoDetail.height">分辨率: {{ videoDetail.width }}x{{ videoDetail.height }}</span>
              </div>
            </div>
          </div>

          <el-form label-width="100px" class="detail-form">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="用户名称:">{{ videoDetail.nickname }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="用户号码:">{{ videoDetail.phone }}</el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="文件大小:">{{ formatFileSize(videoDetail.size) }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="视频状态:">
                  <el-tag :type="getStatusTagType1(videoDetail.reviewStatus)">
                    {{ showApprovalStatus(videoDetail.reviewStatus) }}
                  </el-tag>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="省份:">{{ videoDetail.province || '无' }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="城市:">{{ videoDetail.city || '无' }}</el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="播放量:">{{ formatNumber(videoDetail.viewCount) }}</el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="点赞量:">{{ videoDetail.likeCount || 0 }}</el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="评论量:">{{ videoDetail.commentCount || 0 }}</el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="分享量:">{{ videoDetail.shareCount || 0 }}</el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="收藏量:">{{ videoDetail.collectCount || 0 }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="标签:">{{ videoDetail.tags || '无' }}</el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="创建时间:">{{ videoDetail.createTime }}</el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="更新时间:">{{ videoDetail.updateTime }}</el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="videoDetail.rejectReason">
              <el-col :span="24">
                <el-form-item label="拒绝原因:">
                  <div class="audit-info">
                    <p>{{ videoDetail.rejectReason }}</p>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
    </el-dialog>

    <!-- 审核弹窗 -->
    <el-dialog
      title="视频审核"
      :visible.sync="auditDialogVisible"
      width="500px"
      :before-close="handleAuditClose">
      <el-form :model="auditForm" :rules="auditRules" ref="auditForm" label-width="100px">
        <el-form-item label="审核状态" prop="status">
          <el-radio-group v-model="auditForm.status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">未通过</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="审核原因" prop="reason">
          <el-input
            v-model="auditForm.reason"
            type="textarea"
            :rows="4"
            placeholder="请输入审核原因（未通过时必填）"
            maxlength="200"
            show-word-limit>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="auditDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAudit" :loading="auditSubmitting">提交</el-button>
      </div>
    </el-dialog>

    <!-- 视频播放器弹窗 -->
    <el-dialog
      title="视频播放"
      :visible.sync="videoPlayerVisible"
      width="800px"
      :before-close="handleVideoPlayerClose"
      center>
      <div class="video-player-container" v-if="videoDetail">
        <video
          ref="videoPlayer"
          :src="videoDetail.videoUrl"
          controls
          autoplay
          style="width: 100%; max-height: 500px; border-radius: 8px;"
        >
          您的浏览器不支持视频播放
        </video>
      </div>
    </el-dialog>

    <!-- 用户详情对话框 -->
    <user-detail-dialog
      :visible.sync="userDetailVisible"
      :user-id="selectedUserId">
    </user-detail-dialog>

  </div>

</template>

<script>
  import {axios} from "../../config/axios";
  import UserDetailDialog from '../common/user-detail-dialog.vue';

  export default {
    name: "video-stat",
    components: {
      UserDetailDialog
    },
    data () {
      return {
        // 统计数据
        statistics: {
          totalVideos: 0,
          publishedVideos: 0,
          pendingAudit: 0,
          rejectedVideos: 0,
          totalViews: 0,
          totalLikes: 0,
          videoGrowth: [],
          statusDistribution: []
        },
        // 表格数据
        total: 0,
        tableData: [],
        searchDateArr: [],
        loading: false,
        currentPage: 1,
        // 弹窗控制
        videoDetailVisible: false,
        auditDialogVisible: false,
        auditSubmitting: false,
        videoDetail: null,
        videoPlayerVisible: false,
        // 审核表单
        auditForm: {
          videoId: null,
          status: 1,
          reason: ''
        },
        // 用户详情弹窗
        userDetailVisible: false,
        selectedUserId: null,
        // 搜索条件
        searchInfo: {
          title: '',
          reviewStatus: '',
          nickname: '',
          phone: '',
          productId: '',
          province: '',
          city: '',
          startDate: '',
          endDate: '',
          pageNum: 1,
          pageSize: 20,
        },
        // 下拉列表数据
        statusList: [
          { label: '未审核', value: 0 },
          { label: '审核通过', value: 1 },
          { label: '审核未通过', value: 2 }
        ],
        // 审核表单验证规则
        auditRules: {
          status: [
            { required: true, message: '请选择审核状态', trigger: 'change' }
          ],
          reason: [
            {
              validator: (rule, value, callback) => {
                if (this.auditForm.status === 2 && !value) {
                  callback(new Error('未通过时必须填写审核原因'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ]
        },
        // 日期选择器配置
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        }
      }
    },
    watch: {
      'searchInfo.title'(newVal){
        if (newVal === ""){
          this.getVideoList();
        }
      },
      'searchInfo.nickname'(newVal){
        if (newVal === ""){
          this.getVideoList();
        }
      },
      'searchInfo.phone'(newVal){
        if (newVal === ""){
          this.getVideoList();
        }
      },
      'searchDateArr'(newVal){
        if (newVal === null){
          this.searchInfo.startDate = "";
          this.searchInfo.endDate = "";
          this.getVideoList();
        }
      },
    },
    created() {
      this.getVideoList();
      this.getStatistics();
    },
    methods: {
      // 显示用户详情
      showUserDetail(row) {
        this.selectedUserId = row.userId;
        this.userDetailVisible = true;
      },

      // 搜索
      search() {
        this.currentPage = 1;
        this.searchInfo.pageNum = 1;
        this.getVideoList();
      },

      // 刷新统计数据
      refreshStats() {
        this.getStatistics();
      },

      // 分页处理
      handleCurrentChange(val) {
        this.currentPage = val;
        this.searchInfo.pageNum = val;
        this.getVideoList();
      },

      handleSizeChange(val) {
        this.currentPage = 1;
        this.searchInfo.pageSize = val;
        this.searchInfo.pageNum = 1;
        this.getVideoList();
      },

      // 获取视频列表
      getVideoList() {
        if (this.searchDateArr && this.searchDateArr.length === 2) {
          this.searchInfo.startDate = this.searchDateArr[0];
          this.searchInfo.endDate = this.searchDateArr[1];
        }

        if (this.loading) return;
        this.loading = true;

        axios.get('/video/list', {
          params: this.searchInfo
        }).then(result => {
          this.loading = false;
          if (result.code === 200) {
            this.total = result.data.total;
            this.tableData = result.data.list;
          } else {
            this.$message.error(result.message || '获取数据失败');
          }
        }).catch(err => {
          console.error(err);
          this.loading = false;
          this.$message.error('网络异常，请重试');
        });
      },

      // 获取统计数据
      getStatistics() {
        axios.get('/video/statistics', {
          params: { period: 'month' }
        }).then(result => {
          if (result.code === 200 && result.data) {
            // 确保数据结构完整
            this.statistics = {
              totalVideos: result.data.totalVideos || 0,
              publishedVideos: result.data.publishedVideos || 0,
              pendingAudit: result.data.pendingAudit || 0,
              rejectedVideos: result.data.rejectedVideos || 0,
              totalViews: result.data.totalViews || 0,
              totalLikes: result.data.totalLikes || 0,
              videoGrowth: result.data.videoGrowth || [],
              statusDistribution: result.data.statusDistribution || []
            };
          } else {
            this.$message.warning(result.message || '获取统计数据失败');
          }
        }).catch(err => {
          console.error('获取统计数据失败:', err);
          this.$message.error('获取统计数据异常，请重试');
        });
      },

      showApprovalStatus(val){
        // 0:未审核 1:审核通过 2：审核未通过
        if (val == 2){
            return "审核未通过";
        } else if (val == 1){
            return "审核通过";
        } else{
            return "未审核";
        }
      },
      getStatusTagType1(status) {
        const typeMap = {
          2: 'warning',  // 未审核
          1: 'success',     // 草稿
          0: 'info'
        };
        return typeMap[status] || 'info';
      },
      // 查看视频详情
      viewDetail(row) {
        this.getVideoDetail(row.id);
      },

      // 获取视频详情
      getVideoDetail(id) {
        axios.get(`/video/${id}`).then(result => {
          if (result.code === 200) {
            this.videoDetail = result.data;
            this.videoDetailVisible = true;
          } else {
            this.$message.error('获取视频详情失败');
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('网络异常，请重试');
        });
      },

      // 审核视频
      auditVideo(row) {
        this.auditForm = {
          videoId: row.id,
          status: 1,
          reason: ''
        };
        this.auditDialogVisible = true;
      },

      // 提交审核
      submitAudit() {
        this.$refs.auditForm.validate((valid) => {
          if (valid) {
            this.auditSubmitting = true;

            axios.put(`/video/${this.auditForm.videoId}/review`, null, {
              params: {
                reviewStatus: this.auditForm.status,
                msg: this.auditForm.reason
              }
            }).then(result => {
              this.auditSubmitting = false;
              if (result.code === 200) {
                this.$message.success('审核成功');
                this.auditDialogVisible = false;
                this.getVideoList();
                this.getStatistics();
              } else {
                this.$message.error(result.message || '审核失败');
              }
            }).catch(err => {
              console.error(err);
              this.auditSubmitting = false;
              this.$message.error('网络异常，请重试');
            });
          }
        });
      },

      // 关闭审核弹窗
      handleAuditClose(done) {
        this.auditForm = {
          videoId: null,
          status: 1,
          reason: ''
        };
        if (this.$refs.auditForm) {
          this.$refs.auditForm.clearValidate();
        }
        done();
      },

      // 删除视频
      confirmDelete(row) {
        this.$confirm(`确定要删除视频"${row.title}"吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteVideo(row.id);
        }).catch(() => {
          this.$message.info('已取消删除');
        });
      },

      deleteVideo(id) {
        axios.delete(`/video/${id}`).then(result => {
          if (result.code === 200) {
            this.$message.success('删除成功');
            this.getVideoList();
            this.getStatistics();
          } else {
            this.$message.error(result.message || '删除失败');
          }
        }).catch(err => {
          console.error(err);
          this.$message.error('网络异常，请重试');
        });
      },

      // 双击行事件
      handleRowDblClick(row) {
        this.viewDetail(row);
      },

      // 关闭弹窗
      handleClose(done) {
        this.videoDetail = null;
        done();
      },

      // 播放视频
      playVideo() {
        if (this.videoDetail && this.videoDetail.videoUrl) {
          this.videoPlayerVisible = true;
        } else {
          this.$message.warning('视频地址不存在');
        }
      },

      // 关闭视频播放器
      handleVideoPlayerClose(done) {
        const video = this.$refs.videoPlayer;
        if (video) {
          video.pause();
        }
        this.videoPlayerVisible = false;
        done();
      },

      // 工具方法
      formatDuration(seconds) {
        if (!seconds) return '0秒';
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        if (hours > 0) {
          return `${hours}小时${minutes}分钟${secs}秒`;
        } else if (minutes > 0) {
          return `${minutes}分钟${secs}秒`;
        } else {
          return `${secs}秒`;
        }
      },

      formatNumber(num) {
        if (!num) return '0';
        if (num >= 10000) {
          return (num / 10000).toFixed(1) + '万';
        }
        return num.toString();
      },

      formatFileSize(size) {
        if (!size) return '0B';
        const units = ['B', 'KB', 'MB', 'GB'];
        let index = 0;
        while (size >= 1024 && index < units.length - 1) {
          size /= 1024;
          index++;
        }
        return Math.round(size * 100) / 100 + units[index];
      },

      getStatusText(status) {
        const statusMap = {
          1: '未审核',
          2: '已发布',
          3: '已下架'
        };
        return statusMap[status] || '未知';
      },

      getStatusTagType(status) {
        const typeMap = {
          1: 'warning',
          2: 'success',
          3: 'info'
        };
        return typeMap[status] || 'info';
      }
    }
  }
</script>
<style lang="less" scoped>
  .video-stat {
    .stats-cards {
      margin-bottom: 20px;

      .el-col {
        min-width: 280px;
        margin-top: 30px;
      }

      .stats-card {
        background: #fff;
        border-radius: 8px;
        padding: 10px;
        display: flex;
        align-items: center;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        min-width: 260px;
        transition: transform 0.2s ease, box-shadow 0.2s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
        }

        .stats-icon {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #fff;
          margin-right: 16px;
          flex-shrink: 0;

          &.total {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }
          &.published {
            background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
          }
          &.pending {
            background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
          }
          &.rejected {
            background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
          }
          &.views {
            background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
          }
          &.likes {
            background: linear-gradient(135deg, #ffa751 0%, #ffe259 100%);
          }
        }

        .stats-content {
          flex: 1;
          min-width: 0;

          .stats-number {
            font-size: 24px;
            font-weight: bold;
            color: #333;
            line-height: 1.2;
            word-break: break-all;
          }
          .stats-label {
            font-size: 14px;
            color: #666;
            margin-top: 4px;
            white-space: nowrap;
          }
        }
      }
    }
  }

  .video-detail {
    .video-preview {
      display: flex;
      margin-bottom: 20px;

      .video-cover {
        margin-right: 20px;
        position: relative;

        .play-icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 50px;
          height: 50px;
          background: rgba(0, 0, 0, 0.5);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.3s;

          i {
            font-size: 24px;
            color: #fff;
          }

          &:hover {
            background: rgba(0, 0, 0, 0.7);
            transform: translate(-50%, -50%) scale(1.1);
          }
        }
      }

      .video-info {
        flex: 1;

        h3 {
          margin: 0 0 10px 0;
          color: #333;
          font-size: 18px;
        }

        .description {
          color: #666;
          line-height: 1.5;
          margin-bottom: 15px;
        }

        .meta-info {
          display: flex;
          align-items: center;
          gap: 15px;

          .duration, .resolution {
            color: #999;
            font-size: 14px;
          }
        }
      }
    }

    .detail-form {
      .el-form-item {
        margin-bottom: 12px;
      }
    }

    .audit-info {
      background: #f5f7fa;
      padding: 15px;
      border-radius: 4px;

      p {
        margin: 5px 0;
        color: #606266;
      }
    }
  }

  .searchNav {
    padding: 16px 16px 0 16px;
    background: #fff;
    border-radius: 4px;
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;

    .search-form {
      flex: 1;
      padding-right: 16px;

      .search-items {
        display: flex;
        flex-wrap: wrap;
        margin: 0 -8px;

        .search-item {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          min-width: fit-content;

          .label {
            white-space: nowrap;
            color: #606266;
            font-size: 12px;
          }

          .el-input {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          .el-select {
            width: 180px !important;
            /deep/ .el-input__inner {
              height: 32px;
              line-height: 32px;
            }
          }

          &.date-picker {
            .el-date-editor {
              width: 280px !important;
              /deep/ .el-input__inner {
                height: 32px;
                line-height: 32px;
              }
            }
          }
        }
      }
    }

    .search-btn {
      padding-top: 0;
      .el-button {
        height: 32px;
        line-height: 32px;
        padding: 0 20px;
        margin-left: 8px;
      }
    }
  }

  .tableStyle {
    background: #fff;
    border-radius: 4px;
    overflow: hidden;
  }

  @media screen and (max-width: 1200px) {
    .video-stat .stats-cards {
      .el-col {
        min-width: calc(50% - 20px);
        margin-bottom: 20px;
      }
    }
  }

  @media screen and (max-width: 992px) {
    .video-stat .stats-cards {
      .el-col {
        min-width: calc(50% - 20px);
        margin-bottom: 20px;
      }
    }
  }

  @media screen and (max-width: 768px) {
    .searchNav {
      flex-direction: column;
      padding: 12px;

      .search-form {
        width: 100%;
        padding-right: 0;

        .search-items {
          .search-item {
            width: 100%;

            .el-input, .el-select, .el-date-editor {
              width: 100% !important;
            }
          }
        }
      }

      .search-btn {
        width: 100%;
        margin-top: 16px;
        justify-content: center;
      }
    }

    .video-stat .stats-cards {
      .el-col {
        margin-bottom: 16px;
        min-width: 100%;
      }

      .stats-card {
        min-width: auto;
      }
    }
  }

  @media screen and (max-width: 480px) {
    .video-stat .stats-cards {
      .stats-card {
        padding: 16px;

        .stats-icon {
          width: 50px;
          height: 50px;
          font-size: 20px;
          margin-right: 12px;
        }

        .stats-content {
          .stats-number {
            font-size: 20px;
          }
          .stats-label {
            font-size: 12px;
          }
        }
      }
    }
  }

  /deep/ .el-date-editor .el-range-separator {
    color: #606266 !important;
  }

  .video-player-container {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #000;
    border-radius: 8px;
  }
</style>
